import * as info from "info";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { start as startSettings } from "~/prefs/background";
async function bootstrap() {
    void ewe.sentry.start(webpackDotenvPlugin.SENTRY_DSN, webpackDotenvPlugin.SENTRY_ENVIRONMENT, info.addonVersion);
    startSettings();
}
void bootstrap();
